import { render, staticRenderFns } from "./ProblemList.vue?vue&type=template&id=5216b412&scoped=true"
import script from "./ProblemList.vue?vue&type=script&lang=js"
export * from "./ProblemList.vue?vue&type=script&lang=js"
import style0 from "./ProblemList.vue?vue&type=style&index=0&id=5216b412&prod&lang=scss"
import style1 from "./ProblemList.vue?vue&type=style&index=1&id=5216b412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216b412",
  null
  
)

export default component.exports